export default class ServiceBusController {
    public getManualOffer = async (offerCodes: string[]) => {
        const useCase = () => import('~use-cases/FetchedManualOffers');

        const { FetchedManualOffers } = await useCase();

        new FetchedManualOffers({ offerCodes }).execute();
    };

    public cartItemRemoved = async () => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        new FetchAllViewsUseCase().execute();
    };

    public cartUpdated = async () => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        new FetchAllViewsUseCase().execute();
    };

    public cartOpened = async () => {
        const useCase = () => import('~use-cases/FetchAllViewsUseCase');

        const { FetchAllViewsUseCase } = await useCase();

        new FetchAllViewsUseCase().execute();
    };
}
